(() => {
  if (window.ciStoryRouterInstalled) return;
  window.ciStoryRouterInstalled = true;
  const rootPayload = document.getElementById('ci-home-route');
  if (!rootPayload) return;
  const root = new URL(JSON.parse(rootPayload.textContent), location.origin);
  const main = document.getElementById('MainContent');
  const template = document.getElementById('ci-story-template');
  const current = new URL(location.href);
  // Recover earlier theme links without fetching a section or requiring a Page resource.
  if (current.searchParams.get('view') === 'storia') {
    current.searchParams.delete('view');
    current.pathname = root.pathname;
    current.hash = 'storia';
    if (!template) { location.replace(current.href); return; }
    history.replaceState(null, '', current.href);
  }
  if (!main || !template) return;
  let homeNodes = null;
  const homeTitle = document.title;
  function closeMenus() {
    document.querySelectorAll('.ci-preview-mobile[open], .ci-nav-group[open]').forEach(menu => menu.removeAttribute('open'));
  }
  function showRoute(focus = false) {
    const story = location.hash === '#storia';
    if (story && !homeNodes) {
      homeNodes = document.createDocumentFragment();
      main.querySelectorAll('video').forEach(video => video.pause());
      homeNodes.append(...main.childNodes);
      main.append(template.content.cloneNode(true));
      document.title = 'La nostra storia | ' + homeTitle;
    } else if (!story && homeNodes) {
      main.replaceChildren(homeNodes);
      homeNodes = null;
      document.title = homeTitle;
      // Initialize the homepage if the initial URL opened the story directly.
      document.dispatchEvent(new CustomEvent('shopify:section:load', { detail: { ciRoute: true } }));
    }
    document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin === root.origin && url.pathname === root.pathname && url.hash === '#storia') {
        if (story) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      }
    });
    if (focus) {
      closeMenus();
      if (story) { main.focus({ preventScroll: true }); window.scrollTo(0, 0); }
      else if (location.hash.startsWith('#catalogo')) {
        const catalog = document.getElementById('catalogo');
        catalog?.focus({ preventScroll: true });
        catalog?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
  }
  // Capture restores the homepage before the catalog's existing click handler runs.
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== root.origin || url.pathname !== root.pathname || (url.hash !== '#storia' && !url.hash.startsWith('#catalogo'))) return;
    event.preventDefault();
    const destination = new URL(location.href);
    destination.hash = url.hash;
    destination.searchParams.delete('view');
    if (destination.href !== location.href) history.pushState(null, '', destination.href);
    showRoute(true);
    // pushState does not emit hashchange; synchronize the category for text links too.
    window.dispatchEvent(new Event('hashchange'));
  }, true);
  window.addEventListener('hashchange', () => showRoute(true));
  showRoute();
})();
